module.exports = __webpack_public_path__ + "static/media/logo_text@2x.9179b919.png";